import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconFbSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="12" height="22" viewBox="0 0 12 22" fill="none"
             className={classNames(['svg-icon svg-fb', className])}>
            <path
                d="M7.33464 7.66732V5.00065C7.33464 4.26465 7.93197 3.66732 8.66797 3.66732H10.0013V0.333984H7.33464C5.1253 0.333984 3.33464 2.12465 3.33464 4.33398V7.66732H0.667969V11.0007H3.33464V21.6673H7.33464V11.0007H10.0013L11.3346 7.66732H7.33464Z"
                fill={color}/>
        </svg>

    );
};

IconFbSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconFbSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconFbSVG;